import { Typography } from 'antd';
import React, { ReactElement } from 'react';

interface ErrorFieldProps {
  customMargin?: string;
  errorText?: string;
}

function ErrorField({ customMargin = '2px 0', errorText }: ErrorFieldProps): ReactElement {
  return (
    <Typography.Text type="danger" style={{ display: 'block', margin: customMargin }}>
      {errorText}
    </Typography.Text>
  );
}

export default ErrorField;
